<template>
  <div class="info-region-container">
    <div class="all-content-container">
      <div class="container1">
        <div class="titlemaun">
          <div class="div-h3">
            <h3>环境传感器</h3>
          </div>
          <div class="div-button">
            <el-button type="primary" class="adduser" @click="handleAdd">添加环境传感器</el-button>

          </div>
        </div>
        <div class="div-step">
          <el-steps :active="2" align-center>
            <el-step title="添加环境模型"></el-step>
            <el-step title="添加环境参数"></el-step>
            <el-step title="环境传感器"></el-step>
            <el-step title="执行控制器"></el-step>
            <!-- <el-step title="阶段控制参数"></el-step>  -->
          </el-steps>
        </div>
      </div>
      <div class="container1">
        <el-form :inline="true" :model="searchForm" class="demo-form-inline">
          <el-form-item label="环境参数：" prop="paramId">
            <el-select v-model="searchForm.paramId" placeholder="请选择环境参数" clearable @change="handleSearch">
              <el-option v-for="item in paramArray" :key="item.id" :label="item.paramName" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" class="button" @click="handleSearch">查询</el-button>
            <el-button type="button" ass="button" @click="handleRest">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="info-content-container">
        <div class="table_content1" style="margin-top: 10px">
          <el-table :data="tableData" align="center" class="data-table" v-loading="loading" style="width: 100%" :header-cell-style="{ background: '#F4F5F7' }">
            <el-table-column align="center" label="环境参数">
              <template slot-scope="scope">
                <p>{{ scope.row.paramType | paramTypeName }}</p>
              </template>
            </el-table-column>
            <el-table-column align="center" label="设备名称">
              <template slot-scope="scope">
                <p>{{ scope.row.numericalName }}</p>
              </template>
            </el-table-column>
            <el-table-column align="center" label="属性名称">
              <template slot-scope="scope">
                <p>{{ scope.row.numericalAttrName }}</p>
              </template>
            </el-table-column>
            <el-table-column fixed="right" align="center" label="操作">
              <template slot-scope="scope">
                <el-button @click="handleEdit(scope.row)" type="text" size="small">编辑</el-button>
                <el-button type="text" size="small" @click="handleDel(scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div style="display: flex;justify-content: space-around;">
          <div></div>
          <div class="pagination-container" style="margin-left: 12rem;margin-top: 3rem;">
            <div class="page"></div>
            <div class="pagination-content-container">
              <el-pagination background layout="prev, pager, next, jumper" class="pageTap" @current-change="handleCurrentChange" :current-page="searchForm.pageNum" :page-size="searchForm.pageSize" :total="total"></el-pagination>
            </div>
          </div>
          <div style="margin-top: 3.7rem;">
            <el-button type="primary" class="adduser" @click="handlePrev">上一步</el-button>
            <el-button type="primary" class="adduser" @click="handleNext">下一步</el-button>
            <el-button type="primary" class="adduser" @click="handleReturn">返回环境模型</el-button>
          </div>
        </div>
        <el-dialog :title="addEditTitle" :visible.sync="addEditIsDialog" :before-close="handleCancel" width="600px" center style="z-index: 10000">
          <el-form ref="ruleForm" :rules="rules" :model="ruleForm" label-width="120px" class="demo-ruleForm">
            <el-row>
              <el-col :span="24">
                <el-form-item label="环境参数：" prop="paramId">
                  <el-select v-model="ruleForm.paramId" placeholder="请选择环境参数" clearable @change="paramChange">
                    <el-option v-for="item in paramArray" :key="item.id" :label="item.paramName" :value="item.id"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="设备属性：" prop="deviceAttributeId">
                  <el-select v-model="ruleForm.deviceAttributeId" placeholder="请选择设备属性" clearable @change="deviceAttributeChange">
                    <el-option v-for="item in deviceAttributeArray" :key="item.deviceId + ',' + item.attributeId" :label="item.deviceName + '_' + item.attributeName" :value="item.deviceId + ',' + item.attributeId"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="handleCancel">取 消</el-button>
            <el-button type="primary" @click="handleSave">确 定</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      searchForm: {
        // 查询条件表单字段
        pageNum: 1,
        pageSize: 10,
        evnId: '',
        paramId: ''
      },
      total: 0, // 总条数
      tableData: [], // 表格数据
      loading: false, // 表格加载中是否显示
      ruleForm: {
        // 添加编辑表单字段
        id: '',
        paramId: '',
        numericalId: '',
        numericalAttrId: '',
        deviceAttributeId: ''
      },
      rules: {
        // 添加编辑表单规则
        paramId: [
          {
            required: true,
            message: '请选择环境参数',
            trigger: 'change'
          }
        ],
        deviceAttributeId: [
          {
            required: true,
            message: '请选择设备属性',
            trigger: 'change'
          }
        ]
      },
      addEditTitle: '添加环境传感器', // 添加编辑弹窗标题
      addEditIsDialog: false, // 添加编辑弹窗是否显示
      deviceAttributeArray: [], // 设备属性数组
      paramArray: [], // 环境参数数组
      paramType: undefined // 参数类型
    }
  },
  created() {
    this.searchForm.paramId = this.$route.query.paramId
    this.ruleForm.paramId = this.$route.query.paramId
    this.searchForm.evnId = this.$route.query.evnId

    // 获取环境参数列表
    this.getGrowthModelEvnParamAll()

    // 查询
    this.getList()
  },
  methods: {
    // 查询
    handleSearch() {
      this.searchForm.pageNum = 1
      this.getList()
    },
    // 重置
    handleRest() {
      this.searchForm = {
        pageNum: 1,
        pageSize: 10,
        evnId: this.$route.query.evnId,
        paramId: ''
      }
      this.getList()
    },
    // 分页查询
    handleCurrentChange: function (currentPage) {
      this.searchForm.pageNum = currentPage
      this.getList()
    },
    // 分页获取列表
    getList() {
      this.loading = true
      this.$api.growthModel.getGrowthModelDeviceNumericalList(this.searchForm).then((res) => {
        if (res.code == 200) {
          this.tableData = res.data
          this.total = res.count
          this.loading = false
        }
      })
    },
    // 删除
    handleDel(row) {
      this.$confirm('是否删除？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.$api.growthModel.delGrowthModelDeviceNumerical(row.id).then((res) => {
            if (res.code == 200) {
              this.$message({
                type: 'success',
                message: res.msg
              })
              this.getList()
            }
          })
        })
        .catch(() => {
          this.$message.info('已取消删除')
        })
    },
    // 编辑
    handleEdit(row) {
      this.addEditIsDialog = true
      this.addEditTitle = '编辑环境传感器'
      this.ruleForm.id = row.id
      this.ruleForm.modelId = this.paramId

      // 获取详情
      this.$api.growthModel.getGrowthModelDeviceNumerical({ id: row.id }).then((res) => {
        if (res.code == 200) {
          res.data.deviceAttributeId = res.data.numericalId + ',' + res.data.numericalAttrId
          this.ruleForm = res.data

          // 获取大棚设备标签列表
          this.getControlDevices()
        }
      })
    },
    // 添加
    handleAdd() {
      this.addEditIsDialog = true
      this.addEditTitle = '添加环境传感器'
      this.ruleForm.id = ''
      this.ruleForm.modelId = this.paramId
    },
    // 取消
    handleCancel() {
      this.$refs['ruleForm'].resetFields()
      this.addEditIsDialog = false
    },
    // 保存
    handleSave() {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          this.$api.growthModel.saveGrowthModelDeviceNumerical(this.ruleForm).then((res) => {
            if (res.code == 200) {
              this.$message({
                type: 'success',
                message: res.msg
              })
              this.handleCancel()
              this.handleSearch()
            }
          })
        }
      })
    },
    // 获取大棚设备标签列表
    getControlDevices() {
      this.$api.growthModel
        .getControlDevices({
          type: 0,
          deviceSign: this.paramType,
          groupId: this.$route.query.groupId
        })
        .then((res) => {
          if (res.code == 200) {
            this.deviceAttributeArray = res.data
          }
        })
    },
    // 设备属性下拉切换
    deviceAttributeChange() {
      if (this.ruleForm.deviceAttributeId) {
        let arr = this.ruleForm.deviceAttributeId.split(',')
        this.ruleForm.numericalId = arr[0]
        this.ruleForm.numericalAttrId = arr[1]
      } else {
        this.ruleForm.numericalId = ''
        this.ruleForm.numericalAttrId = ''
      }
    },
    // 获取环境参数列表
    getGrowthModelEvnParamAll() {
      this.$api.growthModel.getGrowthModelEvnParamAll({ evnId: this.$route.query.evnId }).then((res) => {
        if (res.code == 200) {
          res.data.forEach((val) => {
            val.paramName = this.$filters.paramTypeName(val.paramType)
          })
          this.paramArray = res.data
        }
      })
    },
    // 环境参数下拉切换
    paramChange() {
      this.ruleForm.deviceAttributeId = []
      this.ruleForm.numericalId = ''
      this.ruleForm.numericalAttrId = ''
      this.deviceAttributeArray = []

      if (!this.ruleForm.paramId || this.ruleForm.paramId == '') {
        return
      }

      this.paramArray.forEach((val) => {
        if (val.id == Number(this.ruleForm.paramId)) {
          this.paramType = val.paramType
          return
        }
      })

      // 获取大棚设备标签列表
      this.getControlDevices()
    },
    // 返回
    handleReturn() {
      this.$router.push({
        name: `growthModel`,
        query: {
          currentShow: 'second'
        }
      })
    },
    // 上一步
    handlePrev() {
      this.$router.push({
        name: `addEvnParam`,
        query: {
          evnId: this.$route.query.evnId,
          groupId: this.$route.query.groupId
        }
      })
    },
    // 下一步
    handleNext() {
      this.$router.push({
        name: `addDeviceSwitch`,
        query: {
          evnId: this.$route.query.evnId,
          groupId: this.$route.query.groupId
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.all-content-container {
  margin: 0 auto;
  width: 100%;
  margin-top: 10px;

  .container1 {
    border: 1px solid rgba(232, 232, 232, 1);
    margin-top: 10px;
  }

  .div-h3 {
    padding: 15px;
  }

  .div-button {
    margin-top: 0px;
  }

  .div-step {
    margin-top: 20px;
    margin-bottom: 20px;
  }

  .div-footer {
    text-align: center;
    margin-bottom: 50px;
  }

  .titlemaun {
    display: flex;
    justify-content: space-between;
    height: 48px;
    border-bottom: 1px solid #ededed;
  }
}

.demo-ruleForm {
  width: 95%;
  margin: 0 auto;
  padding-top: 10px;

  .el-row {
    margin-bottom: 20px;
  }

  .el-select {
    width: 100% !important;
  }

  .el-input-number {
    width: 100% !important;
  }
}
</style>